/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ELoginResponseStatus = {
    ConfirmEmail: 'ConfirmEmail',
    InvalidMfaCode: 'InvalidMfaCode',
    InvalidRole: 'InvalidRole',
    Lockout: 'Lockout',
    MfaSetup: 'MfaSetup',
    MfaRequired: 'MfaRequired',
    Success: 'Success',
    Unauthorized: 'Unauthorized'
} as const;
export type ELoginResponseStatus = typeof ELoginResponseStatus[keyof typeof ELoginResponseStatus];


export function instanceOfELoginResponseStatus(value: any): boolean {
    for (const key in ELoginResponseStatus) {
        if (Object.prototype.hasOwnProperty.call(ELoginResponseStatus, key)) {
            if (ELoginResponseStatus[key as keyof typeof ELoginResponseStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ELoginResponseStatusFromJSON(json: any): ELoginResponseStatus {
    return ELoginResponseStatusFromJSONTyped(json, false);
}

export function ELoginResponseStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ELoginResponseStatus {
    return json as ELoginResponseStatus;
}

export function ELoginResponseStatusToJSON(value?: ELoginResponseStatus | null): any {
    return value as any;
}

export function ELoginResponseStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): ELoginResponseStatus {
    return value as ELoginResponseStatus;
}

